import type { ReactNode } from 'react';
import cn from '@/utils/merge-class-names';

interface SectionHeaderProps {
  letter?: ReactNode;
  className?: string;
}

function SectionHeader({ letter = '', className }: SectionHeaderProps) {
  return (
    <div className={cn('border-surface mt-4 border-t border-solid pb-2 pt-4 text-sm font-bold', className)}>
      {letter}
    </div>
  );
}

export default SectionHeader;
